module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("From "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Diary of Trevor")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "ch02dairy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Sometimes I think my father never went to Vietnam. I don’t even know why I think that. I just do.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Joe’s father went to Vietnam, and he tells stories. And you can tell, just by the stories, that he really did go.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I think my father maybe just says things sometimes that he thinks will make people proud of him or feel sorry for him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mom feels sorry for him because he went to Vietnam. She says no wonder he has problems. So I don’t tell her that I think maybe he never did.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. St. Clair is so cool. I don’t care what Arnie says. I think he’s great, and I’m gonna do such a great job on that assignment, Mr. St. Clair won’t even be able to believe it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2382e8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02dairy.vue
// module id = 75
// module chunks = 0